import { useCallback, useEffect, useRef, useState } from "react";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import React from "react";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import { IAtivosModel } from "../modules/services/core/_models";
import { RequestMethod } from "../modules/services/core/_enums";
import { useLocation } from "react-router-dom";
import { useAuth } from "../modules/auth";
import Select from "react-select";




const MenuAddAlertAtivo: React.FC = () => {
  const location = useLocation();
  const httpClient = useHttpClient();
  const [detalhesAtivo, setDetalhesAtivo] = useState<IAtivosModel[]>([]);
  const [filteredAtivo, setFilteredAtivo] = useState<IAtivosModel[]>([]);
  const [selectedOrganization, setSelectedOrganization] = useState<string>("");
  const [ativoFilter, setGatewayFilter] = useState<string>("");
  const [selectedAtivo, setSelectedAtivo] = useState<string | null>(null);
  const dataSetNamePBI = getDataSetNamePBI();
  const [dataUsers, setDataUsers] = useState<User[]>([]);
  const [alertLevel, setAlertLevel] = useState<string>("");
  const [responsibleUser, setResponsibleUser] = useState<string>("");
  const [requestingUser, setRequestingUser] = useState<string>("");
  const [ticketNumber, setTicketNumber] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [idemail, setIdemail] = useState<number | null>(null);
  const [chamadosAtivo, setChamadosAtivo] = useState<any[]>([]);
  const [selectedIdPrism, setSelectedIdPrism] = useState<number | null>(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { auth } = useAuth()
  const user = auth?.User
  const emailUsuario = user?.Email
  const [availableOrganizations, setAvailableOrganizations] = useState<
    Organization[]
  >([]);
  const [initialOrganizations, setInitialOrganizations] = useState<string[]>(
    []
  );
  const [selectedOrganizations, setSelectedOrganizations] = useState<string[]>(
    []
  );
  const [userId, setUserId] = useState<string>("");

  interface Organization {
    OrganizationId: string;
    OrganizationName: string;
  }



  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const ativoParam = searchParams.get("ativo")?.trim();

    if (ativoParam) {
      setSelectedAtivo(ativoParam);
      handleAtivoSelection(ativoParam);
    }
  }, [location]);


  const fetchUserId = async () => {
    if (!emailUsuario) {
      console.log("Email do usuário não disponível");
      return;
    }

    try {
      const url = `${backendUrl}/api/User/ByEmail/${encodeURIComponent(
        emailUsuario
      )}`;
      console.log("Fazendo requisição para:", url);

      const response = await fetch(url);
      console.log("Status da resposta:", response.status);

      if (response.ok) {
        const userId = await response.json();
        console.log("Dados do usuário:", userId);
        setUserId(userId.toString()); // Convertendo para string pois o ID vem como número
        return userId.toString(); // Retornando como string para manter consistência
      } else {
        const errorText = await response.text();
        console.error(
          "Erro ao buscar ID do usuário. Status:",
          response.status,
          "Texto:",
          errorText
        );
      }
    } catch (error) {
      console.error("Erro ao buscar ID do usuário:", error);
    }
  };

  // Nova função para buscar organizações do usuário
  const fetchUserOrganizations = async (id: string) => {
    if (!id) {
      console.log("ID do usuário não disponível"); // Debug quando não há ID
      return;
    }

    try {
      const url = `${backendUrl}/api/UserOrganization/OrgByUser?userId=${id}`;
      console.log("Fazendo requisição para:", url); // Debug da URL

      const response = await fetch(url);
      console.log("Status da resposta:", response.status); // Debug do status da resposta

      if (response.ok) {
        const data = await response.json();
        console.log("Organizações recebidas:", data); // Debug das organizações

        if (Array.isArray(data) && data.length > 0) {
          setAvailableOrganizations(data);
          const orgNames = data.map(
            (org: Organization) => org.OrganizationName
          );
          console.log("Nomes das organizações:", orgNames); // Debug dos nomes das organizações
          setInitialOrganizations(orgNames);
        } else {
          console.log(
            "Nenhuma organização encontrada ou formato inválido:",
            data
          );
        }
      } else {
        const errorText = await response.text();
        console.error(
          "Erro ao buscar organizações. Status:",
          response.status,
          "Texto:",
          errorText
        );
      }
    } catch (error) {
      console.error("Erro ao buscar organizações:", error);
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      console.log("Iniciando inicialização dos dados"); // Debug do início da inicialização
      if (emailUsuario) {
        const id = await fetchUserId();
        console.log("ID obtido:", id); // Debug do ID obtido
        if (id) {
          await fetchUserOrganizations(id);
        }
      }
    };

    initializeData();
    obterDetalhesAtivo();
  }, [emailUsuario]);


  const aplicarFiltroOrganizacoes = async (Organizations: string[]) => {
    if (Organizations.length > 0) {
      await obterDetalhesAtivo(Organizations);
      console.log(Organizations); // Filtra os dados por organização
    } else {
      await obterDetalhesAtivo(); // Carrega todos os dados
    }
  };

  const obterDetalhesAtivo = async (orgs?: string[]) => {
    try {
      const endpoint = orgs ? '/Gerenciamento/PowerBI/ObterAtivosByOrg' : '/Gerenciamento/PowerBI/ObterAtivos';

      // Cria um objeto URLSearchParams para construir a query string
      const queryParams = new URLSearchParams();
      if (dataSetNamePBI) {
        queryParams.append('datasetName', dataSetNamePBI);
      }

      if (orgs) {
        orgs.forEach(org => {
          queryParams.append('organization', org);
        });
      }

      // Converte URLSearchParams para string
      const queryString = queryParams.toString();

      // Concatena a query string ao endpoint
      const fullUrl = `${endpoint}?${queryString}`;

      console.log("Full URL:", fullUrl);

      const response = await httpClient.request({
        method: RequestMethod.GET,
        endpoint: fullUrl, // Passa a URL completa com a query string
      });

      if (response.success && response.payload) {
        setDetalhesAtivo(response.payload);
        setFilteredAtivo(response.payload);
        console.log(response.payload);
        console.log(orgs);
      }
    } catch (error) {
      console.error("Erro ao obter visão geral:", error);
    }
  };
  const handleSubmit = async () => {
    // Validação de campos obrigatórios
    if (!selectedAtivo || !subject || !alertLevel || !responsibleUser) {
      alert('Por favor, preencha todos os campos obrigatórios: Ativo, Assunto, Nível do Alerta e Usuário Responsável');
      return;
    }

    // Obtém os detalhes do ativo selecionado
    const selectedAtivoDetails = detalhesAtivo.find(a => a.Ativo.trim() === selectedAtivo.trim());

    if (!selectedAtivoDetails) {
      alert('Ativo não encontrado. Por favor, selecione um ativo válido.');
      return;
    }

    // Verifica se o usuário responsável foi selecionado corretamente
    const responsibleUserObj = dataUsers.find(user => user.Id === parseInt(responsibleUser));
    if (!responsibleUserObj) {
      alert('Usuário responsável inválido. Por favor, selecione novamente.');
      return;
    }

    const matchedOrganization = availableOrganizations.find(
      (org) => org.OrganizationName === selectedAtivoDetails.Organizacao
    );
    const idOrganization = matchedOrganization ? matchedOrganization.OrganizationId : 0;

    // Prepara os dados para envio
    const alertData = {
      Chamado: ticketNumber,
      Assunto: subject,
      Dados: {
        Ativo: selectedAtivoDetails.Ativo,
        Local: selectedAtivoDetails.Local,
        Alerta: "string",
        Alertar: 0,
        IdPrism: selectedAtivoDetails.IdPrism,
        IdBeacon: selectedAtivoDetails.IdBeacon,
        Latitude: selectedAtivoDetails.Latitude || 0,
        Descricao: selectedAtivoDetails.Descricao,
        Longitude: selectedAtivoDetails.Longitude || 0,
        PlaceType: selectedAtivoDetails.PlaceType,
        Nivelalerta: alertLevel.toString(),
        Organizacao: selectedAtivoDetails.Organizacao,
        AtivoSituacao: selectedAtivoDetails.AtivoSituacao,
        IdAlertLevels: parseInt(alertLevel),
        LocalDescricao: selectedAtivoDetails.Local || "",
        TempoDecorrido: selectedAtivoDetails.TempoDecorrido || 0,
        MinutosDeAlerta: 0,
        TempoDeCarencia: "0",
        UltimaVisualizacao: selectedAtivoDetails.UltimaVisualizacao
      },
      IdUsuarioOwner: idemail,
      IdUsuarioResponsible: parseInt(responsibleUser),
      IdOrganization: idOrganization,
      IdPrism: selectedAtivoDetails.IdPrism,
      IdAlertLevel: parseInt(alertLevel)
    };

    console.log('Dados sendo enviados:', alertData);

    try {
      const response = await fetch(`${backendUrl}/api/PrismWorkFlow`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth?.Token}` // Adicione isso se sua API requer autenticação
        },
        body: JSON.stringify(alertData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao criar alerta');
      }

      const responseData = await response.json();
      alert('Alerta criado com sucesso!');
      console.log('Resposta do servidor:', responseData);

      // Limpa os campos após sucesso (opcional)
      setTicketNumber('');
      setSubject('');
      setAlertLevel('');
      setResponsibleUser('');

    } catch (error) {
      console.error('Erro ao criar alerta:', error);
      alert(`Erro ao criar alerta: ${error}`);
    }
  };

  interface User {
    Id: number;
    Email: string;
    Name: string;
    // Adicione outras propriedades se necessário
  };



  useEffect(() => {
    const obterIdEmail = async () => {
      if (emailUsuario) {
        try {
          const response = await fetch(
            `${backendUrl}/api/User/ByEmail/${emailUsuario}`,
            {
              method: "GET",
              headers: {
                accept: "*/*",
              },
            }
          );
          const responseJson = await response.json();
          console.log("responseJson:", responseJson); // Log the response for debugging
          if (responseJson && responseJson) {
            setIdemail(responseJson); // Assuming the response contains an 'id' field
          } else {
            console.error("ID do usuário não encontrado na resposta:", responseJson);
          }
        } catch (error) {
          console.error("Erro ao buscar ID do usuário:", error);
        }
      }
    };

    obterIdEmail();
  }, [emailUsuario]);


  const obterChamadosAtivo = async (ativo: string) => {
    try {
      const response = await fetch(`${backendUrl}/api/PrismWorkFlow/ByAtivo/${ativo}`, {
        method: 'GET',
        headers: {
          'Accept': '*/*',
        },
      });

      if (response.ok) {
        const data3 = await response.json();
        console.log(data3);
        setChamadosAtivo(data3);
      } else {
        console.error('Erro ao buscar dados:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };

  const handleAtivoSelection = useCallback((ativo: string) => {
    const selectedAtivoDetails = detalhesAtivo.find(a => a.Ativo.trim() === ativo.trim());
    if (selectedAtivoDetails) {
      setSelectedAtivo(ativo);
      setSelectedIdPrism(selectedAtivoDetails.IdPrism);
      obterChamadosAtivo(ativo);
    }
  }, [detalhesAtivo]);

  const handleAtivoFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    const ativo = event.target.value;
    setGatewayFilter(ativo);
    filterAtivos(ativo);
  };

  const filterAtivos = (ativo: string) => {
    let filtered = detalhesAtivo;
    if (ativo) {
      filtered = filtered.filter(g => g['Ativo'].includes(ativo));
    }
    setFilteredAtivo(filtered);
  };

  const obterUsuarios = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/User`, {
        method: 'GET',
        headers: {
          'Accept': '*/*',
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setDataUsers(data);
      } else {
        console.error('Erro ao buscar dados:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };

  useEffect(() => {
    obterDetalhesAtivo();
    obterUsuarios();
  }, []);

  return (
    <div className="d-flex" style={{ height: "55vh" }}>
      <div style={{ display: "flex", flexDirection: "column", width: "20%", padding: "10px", marginBottom: "10px" }}>
        {/* Filtro de Organização */}
        <div style={{ flex: 1, maxWidth: "300px", marginBottom: "10px" }}>
          <Select
            isMulti
            options={(() => {
              const opts = availableOrganizations.map((org) => ({
                label: org.OrganizationName,
                value: org.OrganizationName,
              }));
              console.log("Opções do Select:", opts); // Debug das opções do Select
              return opts;
            })()}
            onChange={(selectedOptions: any) => {
              console.log("Opções selecionadas:", selectedOptions); // Debug das seleções
              const selectedOrgs = selectedOptions
                ? selectedOptions.map((opt: any) => opt.value)
                : [];
              setSelectedOrganizations(selectedOrgs);
              aplicarFiltroOrganizacoes(selectedOrgs);
            }}
            placeholder="Filtrar por Organização"
            isClearable
            classNamePrefix="react-select"
          />
        </div>

        {/* Título e Filtro de Ativo */}
        <div style={{ marginBottom: "10px", textAlign: "center" }}>
          <h4 style={{ marginBottom: "10px" }}>Lista de Ativos</h4>
          <input
            type="text"
            placeholder="Digite o codigo do ativo"
            value={ativoFilter}
            onChange={handleAtivoFilter}
            style={{
              width: "100%",
              padding: "5px",
              borderRadius: "5px",
              border: "1px solid var(--bs-border-color)",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              backgroundColor: "var(--bs-body-bg)",
              color: "var(--bs-body-color)",
            }}
          />
        </div>
        {/* Lista de Ativos */}
        <div
          className="sidebar"
          style={{
            borderRight: "1px solid #ccc",
            borderBottom: "1px solid #ccc",
            padding: "10px",
            minHeight: "500px",
            overflowY: "auto",
            maxHeight: "100%",
            borderRadius: "5px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <ul style={{ listStyleType: "none", padding: 0 }}>
            {filteredAtivo && filteredAtivo.length > 0 && filteredAtivo.map((ativo: IAtivosModel) => (
              <li
                key={ativo.Ativo}
                style={{
                  padding: "10px",
                  marginBottom: "8px",
                  border: "1px solid var(--bs-border-color)",
                  borderRadius: "5px",
                  backgroundColor: selectedAtivo?.trim() === ativo.Ativo.trim() ? "var(--bs-secondary-bg)" : "var(--bs-body-bg)",
                  color: "var(--bs-body-color)",
                  fontWeight: selectedAtivo?.trim() === ativo.Ativo.trim() ? "bold" : "normal",
                  cursor: "pointer",
                  transition: "background-color 0.3s ease, color 0.3s ease",
                  textAlign: "center",
                }}
                onClick={() => handleAtivoSelection(ativo.Ativo)}
              >
                {ativo.Ativo}
              </li>
            ))}
          </ul>
        </div>
      </div>


      <div style={{ width: "35%", padding: "10px" }}>
        <h1 style={{ textAlign: "center", marginBottom: "0px", borderBottom: "0px solid var(--bs-border-color)" }}>Inclusão de alertas Ativos</h1>
        {selectedAtivo ? (
          <div
            className="detalhamento-gateway"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "5px",
              padding: "20px",
              border: "2px solid var(--bs-border-color)",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
            }}
          >
            {detalhesAtivo
              .filter((ativo) => ativo.Ativo.trim() === selectedAtivo.trim())
              .slice(0, 1) // Garante apenas 1 item
              .map((ativo, index) => (<React.Fragment key={index}>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Local:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{ativo.Local}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Ativo:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{ativo.Ativo}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Usuário requisitante:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{emailUsuario}</div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>
                  Nro do chamado:
                </div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>
                  <input
                    type="text"
                    value={ticketNumber}
                    onChange={(e) => setTicketNumber(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "5px",
                      borderRadius: "5px",
                      fontWeight: "bold",
                      border: "1px solid var(--bs-border-color)",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "var(--bs-body-bg)",
                      color: "var(--bs-body-color)",
                    }}
                    placeholder="Digite o número do chamado"
                  />
                </div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>
                  Assunto:
                </div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>
                  <input
                    type="text"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "5px",
                      borderRadius: "5px",
                      fontWeight: "bold",
                      border: "1px solid var(--bs-border-color)",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "var(--bs-body-bg)",
                      color: "var(--bs-body-color)",
                    }}
                    placeholder="Digite o assunto"
                  />
                </div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Nivel do alerta:</div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>
                  <select
                    value={alertLevel}
                    onChange={(e) => setAlertLevel(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "5px",
                      borderRadius: "5px",
                      border: "1px solid var(--bs-border-color)",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "var(--bs-body-bg)",
                      color: "var(--bs-body-color)",
                    }}
                  >
                    <option value="">Escolher</option>
                    <option value="1">Atenção</option>
                    <option value="2">Baixo</option>
                    <option value="3">Médio</option>
                    <option value="4">Alto</option>
                    <option value="5">Crítico</option>
                  </select>
                </div>
                <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>
                  Usuário responsável:
                </div>
                <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>
                  <select
                    value={responsibleUser}
                    onChange={(e) => setResponsibleUser(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "5px",
                      borderRadius: "5px",
                      border: "1px solid var(--bs-border-color)",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "var(--bs-body-bg)",
                      color: "var(--bs-body-color)",
                    }}
                  >
                    <option value="">Escolher</option>
                    {dataUsers
                      .sort((a, b) => a.Name.localeCompare(b.Name)) // Ordena os usuários em ordem alfabética
                      .map((user: User) => (
                        <option key={user.Id} value={user.Id}>
                          {user.Name}
                        </option>
                      ))}
                  </select>
                </div>
                <div style={{ marginTop: '20px' }}>
                  <button className="ui primary button" onClick={handleSubmit}>Criar Alerta</button>
                </div>
              </React.Fragment>
              ))}
          </div>
        ) : (
          <p>Selecione um ativo</p>
        )}
      </div>
    </div>
  );
};

export default MenuAddAlertAtivo;